export class FallBackModel {
	text: string;
	cultureCode: string;

	constructor(_text: string, _cultureCode: string) {
		this.text = _text;
		this.cultureCode = _cultureCode;
	}
}
